//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { useGetSamplingCatalogProductsQuery } from '@campaigns/components/campaign-requests/sampling-campaigns/SamplingCampaignsQueries';
import { DEFAULT_LOCALE } from '@campaigns/constants/CampaignRequestsLocaleConstants';
import { useSamplingCampaign } from '@campaigns/hooks/useSamplingCampaign';

interface UseProductSearchProps {
  enabled?: boolean;
  productIds?: string[];
  searchText?: string;
}

export const useProductSearch = ({
  enabled = true,
  productIds,
  searchText,
}: UseProductSearchProps) => {
  const { samplingCampaignRequest, selectedRetailer } = useSamplingCampaign();

  return useGetSamplingCatalogProductsQuery(
    {
      locale: samplingCampaignRequest?.locale ?? DEFAULT_LOCALE,
      productIds,
      retailerId: selectedRetailer?.clientId,
      searchText,
    },
    enabled,
  );
};
